import { render, staticRenderFns } from "./KPagination.vue?vue&type=template&id=20e98c8e&scoped=true&"
import script from "./KPagination.vue?vue&type=script&lang=js&"
export * from "./KPagination.vue?vue&type=script&lang=js&"
import style0 from "./KPagination.vue?vue&type=style&index=0&id=20e98c8e&prod&lang=scss&scoped=true&"
import style1 from "./KPagination.vue?vue&type=style&index=1&id=20e98c8e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20e98c8e",
  null
  
)

export default component.exports